import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=0589c504"
import script from "./Categorias.vue?vue&type=script&lang=ts"
export * from "./Categorias.vue?vue&type=script&lang=ts"
import style0 from "./Categorias.vue?vue&type=style&index=0&id=0589c504&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports